<div class="block-confirmation-modal">
	<h1 mat-dialog-title>{{ data.title | translate:data.params }}</h1>
	<mat-dialog-content class="modal-note">{{ data.note | translate:data.params }}</mat-dialog-content>
	<mat-dialog-actions class="modal-action">
	  <button mat-button
			  *ngFor="let button of data.buttons"
			  [mat-dialog-close]="button.value">{{ button.label | translate }}</button>
	</mat-dialog-actions>
</div>
